import { InputValidatorGenerator } from "./InputValidator";

export const isValidPhoneNumber: InputValidatorGenerator = () => (value) =>
  !!value && /\d{10}/i.test(value)
    ? undefined
    : "Phone number must be in the format: 8008675309";
